// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as IconModuleScss from "../styles/Icon.module.scss";

var styles = IconModuleScss;

function IconCmp(Props) {
  var image = Props.image;
  return React.createElement("div", {
              className: styles.icon
            }, React.createElement(NextImage$PorterinFeature.make, {
                  src: image.src,
                  height: image.height,
                  width: image.width,
                  quality: 70.0,
                  alt: image.alt
                }));
}

var make = IconCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
